import StringUtil from "./StringUtil";
import moment from "moment";

export default class DateUtil {

    /** 
     * 오늘 날짜를 원하는 형식으로 날짜를 설정합니다.
     * */ 
    public static currentDateFormat(format: string) {
        // 현재 날짜를 가져옵니다.
        const today = new Date();
        return moment(today).format(format);
    }

    public static toDateFormat(value: any, format: string) {
        if (value != null) {
            return moment(value).format(format);
        } else {
            return "";
        }
    }
    public static stringToDate(value: string, format: string): Date | undefined {
        if (value != null) {
            // format = format.replaceAll(/-/g, "");
            let year = value.substring(format.indexOf("Y"), format.lastIndexOf("Y") + 1);
            let month = "";
            let day = "";
            if (format.indexOf("Y") !== -1) {
                year = value.substring(format.indexOf("Y"), format.lastIndexOf("Y") + 1);
            }
            if (format.indexOf("y") !== -1) {
                year = value.substring(format.indexOf("y"), format.lastIndexOf("y") + 1);
            }
            if (format.indexOf("M") !== -1) {
                month = value.substring(format.indexOf("M"), format.lastIndexOf("M") + 1);
            }
            if (format.indexOf("m") !== -1) {
                month = value.substring(format.indexOf("m"), format.lastIndexOf("m") + 1);
            }
            if (format.indexOf("D") !== -1) {
                day = value.substring(format.indexOf("D"), format.lastIndexOf("D") + 1);
            }
            if (format.indexOf("d") !== -1) {
                day = value.substring(format.indexOf("d"), format.lastIndexOf("d") + 1);
            }
            if (StringUtil.isNotEmpty(year) && StringUtil.isNotEmpty(month) && StringUtil.isNotEmpty(day)) {
                return new Date(Number(year), Number(month) - 1, Number(day));
            } else if (StringUtil.isNotEmpty(year) && StringUtil.isNotEmpty(month) && StringUtil.isEmpty(day)) {
                return new Date(Number(year), Number(month) - 1, 1);
            } else if (StringUtil.isNotEmpty(year) && StringUtil.isEmpty(month) && StringUtil.isEmpty(day)) {
                return new Date(Number(year), 1, 1);
            } else {
                return undefined;
            }
        } else {
            return undefined;
        }
    }
    public static stringTostring(value: string, format: string) {
        return this.toDateFormat(this.stringToDate(value, format), format);
    }
}
